import React, { useEffect, useState } from "react";
import Axios from "../axios/axios";

export const getCompleteData = async (
  setSpareModels,
  setSpareBrand,
  setSpareCategory
) => {
  try {
    const response = await Axios.get("/type-based-details");
    console.log("API Response:", response.data);
    setSpareModels(response.data.spare.models);
    setSpareBrand(response?.data?.spare?.brands?.map(item => ({
      value: item._id,
      label: item.name,
      categoryId: item.categoryId
    })));
    setSpareCategory(response.data.spare.categories);
  } catch (error) {
    console.error("Error fetching parts:", error);
  }
};

export const getItems = async (setRegion) => {
  try {
    const response = await Axios.get("/regions");
    console.log(response.data);
    setRegion(response.data);
  } catch (error) {
    console.log(error);
  }
};

export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i);
};


export const searchPart = async (filters) => {
  try {
    const response = await Axios.get(`/parts/search?${new URLSearchParams(filters).toString()}`);
    return response.data || [];
  } catch (error) {
    console.error("Error fetching parts:", error.response || error.message);
    return [];
  }
};


export const getFieldValues = async () => {
  try {
    const response = await Axios.get("/parts/field-values");
    console.log("Field Values:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching field values:", error);
    throw error;
  }
};

const HomeAction = () => {
  const [spareModels, setSpareModels] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [spareRegion, setSpareRegion] = useState("");
  const [region, setRegion] = useState([]);

  useEffect(() => {
    getCompleteData(setSpareModels, setSpareBrand);
    getItems(setRegion);
  }, []);

  useEffect(() => {
    // Fetch the distinct field values when component mounts
    getFieldValues();
  }, []);

  return <div></div>;
};

export default HomeAction;
